export const useFormAccessValidation = () => {
  const hasAccess = true;
  return { hasAccess };
};
